/**
 * Airbnb Listing - Complete JavaScript Functionality
 * Handles all modals, gallery, booking, and interactive features
 **/

document.addEventListener('DOMContentLoaded', function() {
    console.log('Airbnb Listing JavaScript loaded');

    // Calendar functionality initialization

    // FIX: Icon Loading - Ensure custom icons display properly
    console.log('=== ICON LOADING FIX ===');
    const iconImages = document.querySelectorAll('.detail-icon-img');
    iconImages.forEach((img, index) => {
        const defaultIcon = img.nextElementSibling;

        // Force show custom icon initially
        img.style.display = 'block';
        if (defaultIcon) defaultIcon.style.display = 'none';
        console.log(`Icon ${index + 1} attempting to load:`, img.src);

        // Add event listeners for dynamic loading
        img.addEventListener('load', () => {
            img.style.display = 'block';
            if (defaultIcon) defaultIcon.style.display = 'none';
            console.log(`Icon ${index + 1} loaded successfully`);
        });
        img.addEventListener('error', () => {
            // Only hide custom and show default on actual error
            img.style.display = 'none';
            if (defaultIcon) defaultIcon.style.display = 'block';
            console.log(`Icon ${index + 1} failed to load, showing default:`, img.src);
        });

        // If image is already complete, check if it loaded
        if (img.complete) {
            if (img.naturalHeight !== 0) {
                img.style.display = 'block';
                if (defaultIcon) defaultIcon.style.display = 'none';
                console.log(`Icon ${index + 1} was already loaded successfully`);
            } else {
                img.style.display = 'none';
                if (defaultIcon) defaultIcon.style.display = 'block';
                console.log(`Icon ${index + 1} was already failed, showing default`);
            }
        }
    });

    // Also handle location icon
    const locationIconImg = document.querySelector('.location-icon-img');
    if (locationIconImg) {
        const locationDefaultIcon = document.querySelector('.default-location-icon');

        // Force show custom icon initially
        locationIconImg.style.display = 'block';
        if (locationDefaultIcon) locationDefaultIcon.style.display = 'none';
        console.log('Location icon attempting to load:', locationIconImg.src);

        locationIconImg.addEventListener('load', () => {
            locationIconImg.style.display = 'block';
            if (locationDefaultIcon) locationDefaultIcon.style.display = 'none';
            console.log('Location icon loaded successfully');
        });
        locationIconImg.addEventListener('error', () => {
            // Only hide custom and show default on actual error
            locationIconImg.style.display = 'none';
            if (locationDefaultIcon) locationDefaultIcon.style.display = 'block';
            console.log('Location icon failed to load, showing default');
        });

        // If image is already complete, check if it loaded
        if (locationIconImg.complete) {
            if (locationIconImg.naturalHeight !== 0) {
                locationIconImg.style.display = 'block';
                if (locationDefaultIcon) locationDefaultIcon.style.display = 'none';
                console.log('Location icon was already loaded successfully');
            } else {
                locationIconImg.style.display = 'none';
                if (locationDefaultIcon) locationDefaultIcon.style.display = 'block';
                console.log('Location icon was already failed, showing default');
            }
        }
    }

    // DEBUG: Similar Properties Section
    console.log('=== SIMILAR PROPERTIES DEBUG ===');
    const similarSection = document.querySelector('.similar-properties-section');
    console.log('Similar properties section found:', !!similarSection);

    // FORCE MOBILE CALENDAR VISIBILITY

    // Initialize all functionality
    initializeGalleryModal();
    initializeInlineGallery();
    initializeGuestModal();
    initializeShowMoreButtons();
    initializeHostAwayBooking();
    initializeMobileFeatures();
    initializeAdminIconUpload();
    initializeInteractiveMap();

});

/**
 * Gallery Modal Functionality
 */
function initializeGalleryModal() {
    const galleryModal = document.getElementById('gallery-modal');
    const galleryTriggers = document.querySelectorAll('[data-gallery-trigger], .photos-count-btn');
    const closeBtn = document.getElementById('gallery-modal-close');
    // Navigation buttons for desktop
    const navPrevBtn = document.getElementById('gallery-nav-prev');
    const navNextBtn = document.getElementById('gallery-nav-next');
    const mainImage = document.getElementById('gallery-main-image');
    const currentIndexEl = document.getElementById('gallery-current-index');
    const totalCountEl = document.getElementById('gallery-total-count');
    const thumbnails = document.querySelectorAll('#gallery-thumbnails .gallery-thumbnail-item');
    
    let currentImageIndex = 0;
    const images = [];
    
    // Comprehensive image collection - collect ALL images from multiple sources
    function collectAllImages() {
        const imageSet = new Set(); // Use Set to avoid duplicates
        const collectedImages = [];
        
        // Primary Method: From modal thumbnails (this contains ALL product images)
        const modalThumbnails = document.querySelectorAll('#gallery-thumbnails img');
        modalThumbnails.forEach((img, index) => {
            if (img.src) {
                const highResSrc = img.src.replace(/width=\d+/, 'width=1200');
                if (!imageSet.has(highResSrc)) {
                    imageSet.add(highResSrc);
                    collectedImages.push({
                        src: highResSrc,
                        alt: img.alt || `Product image ${collectedImages.length + 1}`
                    });
                }
            }
        });
        
        // Fallback Method 1: From main gallery image + thumbnails if modal thumbnails don't exist
        if (collectedImages.length === 0) {
            const galleryMainImage = document.querySelector('.gallery-main-image');
            if (galleryMainImage && galleryMainImage.src) {
                const highResSrc = galleryMainImage.src.replace(/width=\d+/, 'width=1200');
                if (!imageSet.has(highResSrc)) {
                    imageSet.add(highResSrc);
                    collectedImages.push({
                        src: highResSrc,
                        alt: galleryMainImage.alt || 'Product image 1'
                    });
                }
            }
            
            const thumbnailImages = document.querySelectorAll('.gallery-thumbnail-image');
            thumbnailImages.forEach((img, index) => {
                if (img.src) {
                    const highResSrc = img.src.replace(/width=\d+/, 'width=1200');
                    if (!imageSet.has(highResSrc)) {
                        imageSet.add(highResSrc);
                        collectedImages.push({
                            src: highResSrc,
                            alt: img.alt || `Product image ${collectedImages.length + 1}`
                        });
                    }
                }
            });
        }
        
        // Fallback Method 2: From all Shopify images if still no images found
        if (collectedImages.length === 0) {
            document.querySelectorAll('img[src*="cdn.shopify.com"], img[src*="shopify.com"]').forEach((img, index) => {
                if (img.src && !img.src.includes('placeholder')) {
                    const highResSrc = img.src.replace(/width=\d+/, 'width=1200');
                    if (!imageSet.has(highResSrc)) {
                        imageSet.add(highResSrc);
                        collectedImages.push({
                            src: highResSrc,
                            alt: img.alt || `Product image ${collectedImages.length + 1}`
                        });
                    }
                }
            });
        }
        
        // Fallback for testing with more images
        if (collectedImages.length === 0) {
            for (let i = 1; i <= 10; i++) {
                collectedImages.push({
                    src: `https://picsum.photos/800/600?random=${i}`,
                    alt: `Product image ${i}`
                });
            }
        }
        
        console.log('Collected images:', collectedImages.length, collectedImages);
        return collectedImages;
    }
    
    // Collect all images
    images.push(...collectAllImages());
    
    function openGallery(startIndex = 0) {
        // Ensure index is within bounds
        currentImageIndex = Math.max(0, Math.min(startIndex, images.length - 1));

        updateGalleryImage();
        galleryModal.classList.add('active');
        galleryModal.style.display = 'block';
        document.body.style.overflow = 'hidden';

        // Navigation arrows removed - using swipe functionality instead
    }
    
    function closeGallery() {
        galleryModal.classList.remove('active');
        galleryModal.style.display = 'none';
        document.body.style.overflow = '';
    }
    
    function updateGalleryImage(withTransition = false) {
        if (images.length === 0) {
            console.warn('No images available to display');
            return;
        }

        // Ensure currentImageIndex is within bounds
        currentImageIndex = Math.max(0, Math.min(currentImageIndex, images.length - 1));
        const currentImage = images[currentImageIndex];

        if (!currentImage) {
            console.warn('Current image is undefined at index:', currentImageIndex);
            return;
        }

        console.log(`Updating gallery image: ${currentImageIndex + 1}/${images.length} - ${currentImage.src}`);

        // Update main image instantly without loading delay
        if (mainImage) {
            // Set image immediately for instant switching
            mainImage.src = currentImage.src;
            mainImage.alt = currentImage.alt;
            mainImage.style.opacity = '1';

            console.log('Image updated instantly:', currentImage.src);
        }
        
        // Always update counter elements
        if (currentIndexEl) {
            currentIndexEl.textContent = currentImageIndex + 1;
        }
        
        if (totalCountEl) {
            totalCountEl.textContent = images.length;
        }
        
        // Update thumbnail active state with better selector
        const allThumbnails = document.querySelectorAll('#gallery-thumbnails .gallery-thumbnail-item');
        allThumbnails.forEach((thumb, index) => {
            thumb.classList.toggle('active', index === currentImageIndex);
        });
        
        // Ensure active thumbnail is visible in the scroll area
        const activeThumbnail = document.querySelector('#gallery-thumbnails .gallery-thumbnail-item.active');
        if (activeThumbnail) {
            activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        
        // Navigation buttons removed - using swipe functionality instead
    }
    
    // Make navigation functions globally accessible for mobile touch handlers
    window.galleryNextImage = function(withTransition = false) {
        if (images.length === 0) {
            console.warn('No images available for navigation');
            return;
        }
        
        const prevIndex = currentImageIndex;
        currentImageIndex = (currentImageIndex + 1) % images.length;
        updateGalleryImage(withTransition);
        console.log(`Next image: ${prevIndex + 1} -> ${currentImageIndex + 1}/${images.length}`);
    };
    
    window.galleryPrevImage = function(withTransition = false) {
        if (images.length === 0) {
            console.warn('No images available for navigation');
            return;
        }
        
        const prevIndex = currentImageIndex;
        currentImageIndex = (currentImageIndex - 1 + images.length) % images.length;
        updateGalleryImage(withTransition);
        console.log(`Previous image: ${prevIndex + 1} -> ${currentImageIndex + 1}/${images.length}`);
    };
    
    // Local references for backward compatibility
    const nextImage = window.galleryNextImage;
    const prevImage = window.galleryPrevImage;
    
    // Event listeners for gallery triggers
    galleryTriggers.forEach((trigger, index) => {
        trigger.addEventListener('click', (e) => {
            // Mobile: Don't open modal for main image and thumbnails
            if (window.innerWidth <= 767) {
                if (trigger.classList.contains('gallery-main-item') || 
                    trigger.classList.contains('gallery-thumbnail-item')) {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('Mobile: Gallery modal prevented for', trigger.className);
                    return;
                }
            }

            e.preventDefault();
            e.stopPropagation();

            // Determine start index
            let startIndex = 0;
            if (trigger.dataset.index !== undefined) {
                startIndex = parseInt(trigger.dataset.index);
            } else if (trigger.classList.contains('gallery-thumbnail-item')) {
                // For thumbnails, find the index in the thumbnail container
                const thumbnailItems = document.querySelectorAll('.gallery-thumbnail-item');
                startIndex = Array.from(thumbnailItems).indexOf(trigger) + 1; // +1 because main image is index 0
            } else if (trigger.classList.contains('gallery-main-item')) {
                startIndex = 0; // Main image is always index 0
            }

            console.log('Gallery trigger clicked:', trigger.className, 'starting at index:', startIndex, 'trigger element:', trigger);
            openGallery(startIndex);
        });
    });
    
    if (closeBtn) {
        closeBtn.addEventListener('click', closeGallery);
    }

    // Desktop navigation buttons - only add listeners if buttons exist
    if (navPrevBtn && navNextBtn) {
        navPrevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.galleryPrevImage();
        });

        navNextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.galleryNextImage();
        });

        console.log('Desktop navigation buttons initialized');
    }
    
    // Enhanced thumbnail clicks in modal with better navigation
    function setupThumbnailNavigation() {
        const modalThumbnails = document.querySelectorAll('#gallery-thumbnails .gallery-thumbnail-item');
        console.log('Setting up thumbnail navigation for', modalThumbnails.length, 'thumbnails');
        
        modalThumbnails.forEach((thumb, index) => {
            thumb.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                if (index < images.length) {
                    currentImageIndex = index;
                    updateGalleryImage();
                    console.log(`Thumbnail clicked: ${currentImageIndex + 1}/${images.length}`);
                } else {
                    console.warn('Thumbnail index out of bounds:', index, 'images available:', images.length);
                }
            });
            
            // Add touch support for mobile
            thumb.addEventListener('touchstart', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                if (index < images.length) {
                    currentImageIndex = index;
                    updateGalleryImage();
                    console.log(`Thumbnail touched: ${currentImageIndex + 1}/${images.length}`);
                } else {
                    console.warn('Thumbnail index out of bounds:', index, 'images available:', images.length);
                }
            });
        });
    }
    
    // Setup thumbnail navigation after DOM is ready
    setupThumbnailNavigation();
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
        if (!galleryModal.classList.contains('active')) return;
        
        switch(e.key) {
            case 'Escape':
                closeGallery();
                break;
            case 'ArrowLeft':
                prevImage();
                break;
            case 'ArrowRight':
                nextImage();
                break;
        }
    });
    
    // Close on overlay click
    galleryModal.addEventListener('click', (e) => {
        if (e.target === galleryModal || e.target.classList.contains('gallery-modal-overlay')) {
            closeGallery();
        }
    });
    
    // Debug function to analyze DOM structure
    function debugGalleryStructure() {
        console.log('=== Gallery Structure Debug ===');
        
        const modalThumbnails = document.querySelectorAll('#gallery-thumbnails img');
        console.log('Modal thumbnails found:', modalThumbnails.length);
        modalThumbnails.forEach((img, i) => {
            console.log(`  Thumbnail ${i + 1}: ${img.src}`);
        });
        
        const galleryMainImage = document.querySelector('.gallery-main-image');
        console.log('Main gallery image:', galleryMainImage ? galleryMainImage.src : 'not found');
        
        const thumbnailImages = document.querySelectorAll('.gallery-thumbnail-image');
        console.log('Gallery thumbnail images:', thumbnailImages.length);
        
        console.log('Modal elements check:');
        console.log('  - Gallery modal:', !!galleryModal);
        console.log('  - Main image element:', !!mainImage);
        console.log('  - Current index element:', !!currentIndexEl);
        console.log('  - Total count element:', !!totalCountEl);
        console.log('  - Navigation buttons:', !!navPrevBtn && !!navNextBtn);
        
        console.log('=== End Debug ===');
    }
    
    // Function to ensure all images have corresponding thumbnails in the modal
    function ensureModalThumbnails() {
        const thumbnailContainer = document.querySelector('#gallery-thumbnails');
        if (!thumbnailContainer) {
            console.warn('Gallery thumbnails container not found');
            return;
        }
        
        // Clear existing thumbnails
        thumbnailContainer.innerHTML = '';
        
        // Create thumbnails for all images
        images.forEach((image, index) => {
            const thumbnailItem = document.createElement('div');
            thumbnailItem.className = 'gallery-thumbnail-item';
            if (index === 0) {
                thumbnailItem.classList.add('active');
            }
            thumbnailItem.dataset.index = index.toString();
            
            const thumbnailImg = document.createElement('img');
            thumbnailImg.src = image.src.replace(/width=\d+/, 'width=100');
            thumbnailImg.alt = `${image.alt || 'Product image'} - Thumbnail ${index + 1}`;
            
            thumbnailItem.appendChild(thumbnailImg);
            thumbnailContainer.appendChild(thumbnailItem);
        });
        
        console.log('Created', images.length, 'modal thumbnails');
    }
    
    // Initialize the gallery UI properly with enhanced setup
    function finalizeGallerySetup() {
        // Run debug first
        debugGalleryStructure();
        
        // Ensure modal thumbnails exist for all images
        ensureModalThumbnails();
        
        if (totalCountEl) {
            totalCountEl.textContent = images.length;
        }
        if (currentIndexEl) {
            currentIndexEl.textContent = '1';
        }
        
        // Desktop navigation buttons are now active
        
        // Pre-load first image for better performance
        if (images.length > 0 && mainImage) {
            const firstImage = new Image();
            firstImage.onload = function() {
                console.log('First gallery image preloaded successfully');
            };
            firstImage.src = images[0].src;
        }
        
        console.log('Gallery modal initialized with', images.length, 'images');
        console.log('Image sources:', images.map((img, i) => `${i + 1}: ${img.src}`));
        
        // Re-run thumbnail navigation setup after images are collected
        setupThumbnailNavigation();
    }
    
    // Initialize after a small delay to ensure DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', finalizeGallerySetup);
    } else {
        // Use setTimeout to ensure all DOM elements are fully rendered
        setTimeout(finalizeGallerySetup, 100);
    }
}

/**
 * Inline Gallery Functionality - for main gallery section with proper sliding carousel
 */
function initializeInlineGallery() {
    let currentMainIndex = 0;
    const mainContainer = document.querySelector('.gallery-main-container');
    const thumbnailItems = document.querySelectorAll('.gallery-thumbnail-item');

    if (!mainContainer) {
        console.log('Inline gallery container not found');
        return;
    }

    // Collect all image sources with better error handling
    const allImages = [];

    // Get main image first
    const mainImage = document.querySelector('.gallery-main-image');
    if (mainImage && mainImage.src) {
        const highResMain = mainImage.src.replace(/width=\d+/, 'width=800');
        allImages.push(highResMain);
    }

    // Add thumbnail images
    thumbnailItems.forEach((thumb, index) => {
        const img = thumb.querySelector('img, .gallery-thumbnail-image');
        if (img && img.src && img.src !== mainImage?.src) {
            const highResThumb = img.src.replace(/width=\d+/, 'width=800');
            allImages.push(highResThumb);
        }
    });

    // Fallback: If we only have main image, create some test images
    if (allImages.length === 1) {
        // Try to find more images from the modal thumbnails
        const modalThumbnails = document.querySelectorAll('#gallery-thumbnails img');
        modalThumbnails.forEach((img, index) => {
            if (img.src && !allImages.includes(img.src)) {
                const highResSrc = img.src.replace(/width=\d+/, 'width=800');
                allImages.push(highResSrc);
            }
        });
    }

    // If still only one image, add some test images for demonstration
    if (allImages.length === 1) {
        console.log('Only one image found, adding demo images for swipe testing');
        // Add some demo product images
        for (let i = 2; i <= 5; i++) {
            allImages.push(`https://picsum.photos/800/600?random=${i}&sig=${Date.now()}`);
        }
        console.log('Added demo images for testing. Total images:', allImages.length);
    }

    console.log('🖼️ Inline gallery initialized with', allImages.length, 'images');
    console.log('📋 Image sources:', allImages.map((img, i) => `${i + 1}: ${img.substring(0, 50)}...`));

    // Create proper sliding carousel
    if (allImages.length > 1) {
        createSlidingCarousel();
    }

    function createSlidingCarousel() {
        // Create carousel container
        const carouselContainer = document.createElement('div');
        carouselContainer.className = 'gallery-carousel';
        carouselContainer.style.cssText = `
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 12px;
        `;

        // Create slides container
        const slidesContainer = document.createElement('div');
        slidesContainer.className = 'gallery-slides';
        slidesContainer.style.cssText = `
            display: flex;
            width: ${allImages.length * 100}%;
            height: 100%;
            transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            will-change: transform;
        `;

        // Create individual slides
        allImages.forEach((src, index) => {
            const slide = document.createElement('div');
            slide.className = 'gallery-slide';
            slide.style.cssText = `
                flex: 0 0 ${100 / allImages.length}%;
                width: ${100 / allImages.length}%;
                height: 100%;
                position: relative;
            `;

            const img = document.createElement('img');
            img.src = src;
            img.alt = `Gallery image ${index + 1}`;
            img.style.cssText = `
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
                display: block;
            `;

            slide.appendChild(img);
            slidesContainer.appendChild(slide);
        });

        carouselContainer.appendChild(slidesContainer);

        // Replace the existing content
        mainContainer.innerHTML = '';
        mainContainer.appendChild(carouselContainer);

        // Update carousel position
        function updateCarouselPosition() {
            const translateX = -currentMainIndex * (100 / allImages.length);
            slidesContainer.style.transform = `translateX(${translateX}%)`;
            console.log('🔄 Updated carousel position to index', currentMainIndex, 'translateX:', translateX + '%');

            // Update thumbnail active state
            thumbnailItems.forEach((thumb, i) => {
                thumb.classList.toggle('active', i === currentMainIndex - 1); // -1 because main is 0
            });
        }

        // Navigation functions
        function nextImage() {
            if (allImages.length <= 1) {
                console.log('❌ Cannot navigate: only', allImages.length, 'image(s) available');
                return;
            }
            const newIndex = (currentMainIndex + 1) % allImages.length;
            console.log('🔄 Next image: moving from index', currentMainIndex, 'to', newIndex);
            currentMainIndex = newIndex;
            updateCarouselPosition();
        }

        function prevImage() {
            if (allImages.length <= 1) {
                console.log('❌ Cannot navigate: only', allImages.length, 'image(s) available');
                return;
            }
            const newIndex = currentMainIndex === 0 ? allImages.length - 1 : currentMainIndex - 1;
            console.log('🔄 Previous image: moving from index', currentMainIndex, 'to', newIndex);
            currentMainIndex = newIndex;
            updateCarouselPosition();
        }

        // Initialize position
        updateCarouselPosition();

        // Desktop click navigation - left/right half of carousel
        if (window.innerWidth > 767) {
            carouselContainer.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const rect = carouselContainer.getBoundingClientRect();
                const clickX = e.clientX - rect.left;
                const halfWidth = rect.width / 2;

                if (clickX < halfWidth) {
                    // Clicked left half - previous image
                    prevImage();
                    console.log('Desktop: clicked left half, going to previous image');
                } else {
                    // Clicked right half - next image
                    nextImage();
                    console.log('Desktop: clicked right half, going to next image');
                }
            });
            console.log('Desktop gallery click navigation enabled');
        }

        // Mobile behavior - thumbnails update carousel, no modal on tap
        thumbnailItems.forEach((thumb, index) => {
            thumb.addEventListener('click', (e) => {
                if (window.innerWidth <= 767) {
                    // Mobile: just update carousel, don't open modal
                    e.preventDefault();
                    e.stopPropagation();
                    currentMainIndex = index + 1; // +1 because main is 0
                    updateCarouselPosition();
                    console.log('Mobile: thumbnail clicked, updated carousel');
                } else {
                    // Desktop: prevent default but allow modal trigger from parent handlers
                    e.preventDefault();
                    currentMainIndex = index + 1;
                    updateCarouselPosition();
                }
            });
        });

        // Enhanced mobile swipe functionality for carousel
        const isMobileDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || window.innerWidth <= 768;

        if (allImages.length > 1 && isMobileDevice) {
            let startX = 0;
            let startY = 0;
            let isSwiping = false;
            let swipeThreshold = 30;
            let swipeMinDistance = 30;

            // Prevent modal opening on carousel tap
            carouselContainer.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('✅ Mobile: prevented modal opening on carousel');
            });

            carouselContainer.addEventListener('touchend', (e) => {
                if (!isSwiping) {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('✅ Mobile: prevented modal opening on touch end');
                }
            }, { passive: false });

            // Touch handlers for carousel swipe
            carouselContainer.addEventListener('touchstart', function(e) {
                if (e.touches.length === 1) {
                    startX = e.touches[0].clientX;
                    startY = e.touches[0].clientY;
                    isSwiping = false;
                    console.log('🔥 Touch start at:', startX, startY);

                    // Reset carousel state
                    carouselContainer.classList.remove('swiping');
                    slidesContainer.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
                }
            }, { passive: true });

            carouselContainer.addEventListener('touchmove', function(e) {
                if (e.touches.length === 1) {
                    const moveX = e.touches[0].clientX;
                    const moveY = e.touches[0].clientY;
                    const diffX = Math.abs(moveX - startX);
                    const diffY = Math.abs(moveY - startY);

                    // Start swipe detection
                    if (diffX > swipeThreshold && !isSwiping) {
                        if (diffX > diffY * 1.2) {
                            isSwiping = true;
                            e.preventDefault();
                            console.log('📱 Horizontal swipe detected on carousel');

                            carouselContainer.classList.add('swiping');
                        }
                    }

                    // Apply live transform during swipe
                    if (isSwiping) {
                        e.preventDefault();
                        const currentTranslate = -currentMainIndex * (100 / allImages.length);
                        const dragAmount = ((moveX - startX) / carouselContainer.offsetWidth) * (100 / allImages.length);
                        const newTranslate = currentTranslate + dragAmount;
                        slidesContainer.style.transform = `translateX(${newTranslate}%)`;
                    }
                }
            }, { passive: false });

            carouselContainer.addEventListener('touchend', function(e) {
                if (e.changedTouches.length === 1 && isSwiping) {
                    const endX = e.changedTouches[0].clientX;
                    const swipeDistance = startX - endX;

                    console.log('📏 Swipe distance:', swipeDistance, 'isSwiping:', isSwiping);
                    console.log('📊 Available images:', allImages.length, 'Current index:', currentMainIndex);

                    // Determine swipe direction and navigate
                    if (Math.abs(swipeDistance) > swipeMinDistance) {
                        if (swipeDistance > 0) {
                            // Swiped left - next image
                            console.log('➡️ Swiped left - next image');
                            nextImage();
                        } else {
                            // Swiped right - previous image
                            console.log('⬅️ Swiped right - previous image');
                            prevImage();
                        }

                        // Brief pointer events disable
                        carouselContainer.style.pointerEvents = 'none';
                        setTimeout(() => {
                            carouselContainer.style.pointerEvents = '';
                        }, 200);
                    } else {
                        // Swipe too small, animate back to current position
                        console.log('❌ Swipe too small, returning to current position');
                        updateCarouselPosition();
                    }

                    carouselContainer.classList.remove('swiping');
                }

                // Reset state
                setTimeout(() => {
                    isSwiping = false;
                }, 350);
            }, { passive: true });

            console.log('✅ Enhanced mobile carousel swipe enabled for', allImages.length, 'images');
            console.log('🎯 Mobile carousel settings:', {
                swipeThreshold: swipeThreshold + 'px',
                swipeMinDistance: swipeMinDistance + 'px',
                imagesAvailable: allImages.length
            });

            // Debug: List all available images
            console.log('🖼️ Available images for carousel swiping:');
            allImages.forEach((img, index) => {
                console.log(`  ${index + 1}: ${img}`);
            });

            console.log('👆 Swipe left/right on the carousel to navigate through', allImages.length, 'images');
        }
    }
}

/**
 * Guest Modal Functionality
 */
function initializeGuestModal() {
    const guestModal = document.getElementById('guests-modal');
    const guestSelect = document.getElementById('guests-select');
    const closeGuestsBtn = document.querySelector('.close-guests-btn');
    const guestDisplay = document.getElementById('guests-display');
    const counterBtns = document.querySelectorAll('.counter-btn');
    
    let guestCounts = {
        adults: 1,
        children: 0,
        infants: 0,
        pets: 0
    };
    
    function openGuestModal() {
        guestModal.classList.add('active');
        guestModal.style.display = 'flex';
        document.body.classList.add('modal-open');
        updateCounterDisplays();
    }
    
    function closeGuestModal() {
        guestModal.classList.remove('active');
        guestModal.style.display = 'none';
        document.body.classList.remove('modal-open');
        updateGuestDisplay();
    }
    
    function updateCounterDisplays() {
        Object.keys(guestCounts).forEach(type => {
            const counterEl = document.getElementById(`${type}-count`);
            if (counterEl) {
                counterEl.textContent = guestCounts[type];
            }
        });
        updateCounterButtons();
    }
    
    function updateCounterButtons() {
        counterBtns.forEach(btn => {
            const action = btn.dataset.action;
            const type = btn.dataset.type;
            
            if (action === 'decrease') {
                const minValue = type === 'adults' ? 1 : 0;
                btn.disabled = guestCounts[type] <= minValue;
            }
        });
    }
    
    function updateGuestDisplay() {
        if (!guestDisplay) return;
        
        const totalGuests = guestCounts.adults + guestCounts.children;
        let displayText = '';
        
        if (totalGuests === 1) {
            displayText = '1 guest';
        } else if (totalGuests > 1) {
            displayText = `${totalGuests} guests`;
        } else {
            displayText = 'Add guests';
        }
        
        if (guestCounts.infants > 0) {
            displayText += `, ${guestCounts.infants} infant${guestCounts.infants > 1 ? 's' : ''}`;
        }
        
        if (guestCounts.pets > 0) {
            displayText += `, ${guestCounts.pets} pet${guestCounts.pets > 1 ? 's' : ''}`;
        }
        
        guestDisplay.textContent = displayText;
    }
    
    // Event listeners
    if (guestSelect) {
        guestSelect.addEventListener('click', (e) => {
            e.preventDefault();
            openGuestModal();
        });
    }
    
    if (closeGuestsBtn) {
        closeGuestsBtn.addEventListener('click', closeGuestModal);
    }
    
    counterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const action = btn.dataset.action;
            const type = btn.dataset.type;
            
            if (action === 'increase') {
                guestCounts[type]++;
            } else if (action === 'decrease') {
                const minValue = type === 'adults' ? 1 : 0;
                if (guestCounts[type] > minValue) {
                    guestCounts[type]--;
                }
            }
            
            updateCounterDisplays();
        });
    });
    
    // Close on overlay click
    if (guestModal) {
        guestModal.addEventListener('click', (e) => {
            if (e.target === guestModal) {
                closeGuestModal();
            }
        });
    }
    
    // Initialize display
    updateGuestDisplay();
    console.log('Guest modal initialized');
}

/**
 * Show More Buttons - All Modals
 */
function initializeShowMoreButtons() {
    const modalConfigs = {
        '.show-more-description-btn': '#description-modal',
        '.show-all-amenities-btn': '#amenities-modal',
        '.show-more-safety-btn': '#safety-modal',
        '.show-more-cancellation-btn': '#cancellation-modal',
        '.show-all-reviews-btn': '#reviews-modal'
    };
    
    Object.entries(modalConfigs).forEach(([buttonSelector, modalSelector]) => {
        const buttons = document.querySelectorAll(buttonSelector);
        const modal = document.querySelector(modalSelector);
        
        if (modal) {
            buttons.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    openModal(modal);
                });
            });
        }
    });
    
    // Close modal functionality
    document.querySelectorAll('.close-modal').forEach(closeBtn => {
        closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const modal = closeBtn.closest('.modal');
            if (modal) {
                closeModal(modal);
            }
        });
    });
    
    function openModal(modal) {
        modal.classList.add('active');
        modal.style.display = 'flex';
        document.body.classList.add('modal-open');
    }
    
    function closeModal(modal) {
        modal.classList.remove('active');
        modal.style.display = 'none';
        document.body.classList.remove('modal-open');
    }
    
    // Close on overlay click
    document.querySelectorAll('.modal').forEach(modal => {
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                closeModal(modal);
            }
        });
    });
    
    console.log('Show more buttons initialized');
}

/**
 * HostAway Booking Integration
 */
function initializeHostAwayBooking() {
    // HostAway buttons are now handled directly in the Liquid template
    // This function ensures proper behavior and handles any dynamic updates
    
    const hostAwayButtons = document.querySelectorAll('.hostaway-btn');
    
    if (hostAwayButtons.length > 0) {
        console.log(`Found ${hostAwayButtons.length} HostAway booking buttons`);
        
        // Ensure all HostAway buttons have proper click handling
        hostAwayButtons.forEach(button => {
            // Verify the button has a valid URL
            const hostAwayUrl = button.dataset.hostawayUrl || button.href;
            
            if (!hostAwayUrl || hostAwayUrl === '' || hostAwayUrl === '#') {
                console.warn('HostAway button found without valid URL:', button);
                button.style.display = 'none';
                return;
            }
            
            // Add click tracking if needed (optional)
            button.addEventListener('click', (e) => {
                console.log('HostAway booking initiated:', hostAwayUrl);
                // Add any tracking or analytics here if needed
            });
            
            // Ensure the button opens in a new tab
            button.target = '_blank';
            button.rel = 'noopener noreferrer';
        });
    } else {
        console.log('No HostAway booking buttons found - using fallback behavior');
    }
    
    // Handle fallback booking unavailable buttons
    const unavailableButtons = document.querySelectorAll('.booking-unavailable-btn');
    unavailableButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            alert('Booking is currently unavailable. Please contact us directly for reservations.');
        });
    });
}

/**
 * Calendar functionality now handled by Hostaway widget
 */

/**
 * Toast system removed - calendar functionality now handled by Hostaway widget
 */

/**
 * Booking functionality now handled by Hostaway widget
 */

/**
 * Updates all maps on the page with coordinates from a message
 * @param {Object} data - Message data containing lat, lng, and zoom
 */
function updateAllMapsFromMessage(data) {
    // Validate data
    const lat = parseFloat(data.lat);
    const lng = parseFloat(data.lng);
    const zoom = parseInt(data.zoom);
    
    if (isNaN(lat) || isNaN(lng) || isNaN(zoom)) {
        console.error('Invalid map update data:', data);
        return;
    }
    
    console.log(`Updating all maps to: ${lat}, ${lng}, zoom: ${zoom}`);
    
    // Find all map instances
    const mapContainers = document.querySelectorAll('.map-interactive');
    
    mapContainers.forEach((container, index) => {
        // Update Leaflet maps
        if (container._leaflet_id) {
            const map = container._leaflet;
            if (map) {
                // Update view without triggering moveend event
                map.off('moveend');
                map.setView([lat, lng], zoom);
                
                // Update marker position
                const markers = map._layers;
                for (const id in markers) {
                    if (markers[id] instanceof L.Marker) {
                        markers[id].setLatLng([lat, lng]);
                    }
                }
                
                // Re-attach moveend event
                map.on('moveend', function() {
                    const center = map.getCenter();
                    updateMapUrlParameters(center.lat, center.lng, map.getZoom());
                });
                
                console.log(`Updated Leaflet map ${index}`);
            }
        }
        // Update Google Maps
        else if (container.gmap) {
            const map = container.gmap;
            const newCenter = new google.maps.LatLng(lat, lng);
            
            // Update map center and zoom
            map.setCenter(newCenter);
            map.setZoom(zoom);
            
            // Update marker position
            if (container.marker) {
                container.marker.setPosition(newCenter);
            }
            
            console.log(`Updated Google map ${index}`);
        }
    });
}

/**
 * Updates the URL parameters with map coordinates and zoom level
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @param {number} zoom - Zoom level
 */
function updateMapUrlParameters(lat, lng, zoom) {
    // Round coordinates to 6 decimal places for URL cleanliness
    lat = parseFloat(lat).toFixed(6);
    lng = parseFloat(lng).toFixed(6);
    zoom = parseInt(zoom);
    
    // Create URL with parameters
    const url = new URL(window.location.href);
    const params = url.searchParams;
    
    // Update parameters
    params.set('lat', lat);
    params.set('lng', lng);
    params.set('zoom', zoom);
    
    // Replace URL without reloading the page
    window.history.replaceState({}, '', url);
    console.log('Updated URL with map parameters:', lat, lng, zoom);
    
    // Check if we're in an iframe
    if (window !== window.parent) {
        // We're in an iframe, send message to parent
        window.parent.postMessage({
            type: 'mapUpdate',
            lat: lat,
            lng: lng,
            zoom: zoom
        }, '*');
        console.log('Sent map parameters to parent frame');
    }
    
    // Check if we're the parent and need to update iframe
    if (window === window.parent) {
        // Find map iframes and update them
        const mapIframes = document.querySelectorAll('iframe.map-frame');
        mapIframes.forEach(iframe => {
            try {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage({
                        type: 'mapUpdate',
                        lat: lat,
                        lng: lng,
                        zoom: zoom
                    }, '*');
                    console.log('Sent map parameters to iframe');
                }
            } catch (e) {
                console.error('Error sending message to iframe:', e);
            }
        });
    }
}

/**
 * Admin Custom Icon Upload Feature
 */
function initializeAdminIconUpload() {
    const adminPanel = document.querySelector('.admin-panel');
    const isAdmin = document.body.dataset.userRole === 'admin' || localStorage.getItem('isAdmin') === 'true';
    
    if (!isAdmin) {
        console.log('Admin icon upload: User is not admin, skipping');
        return;
    }
    
    console.log('Initializing admin custom icon upload');
    
    // Create admin icon upload interface if it doesn't exist
    if (!document.getElementById('admin-icon-upload')) {
        createAdminIconInterface();
    }
    
    const uploadBtn = document.getElementById('admin-icon-upload');
    const fileInput = document.getElementById('admin-icon-file-input');
    const previewContainer = document.getElementById('admin-icon-preview');
    const applyBtn = document.getElementById('admin-apply-icon');
    
    if (uploadBtn && fileInput) {
        uploadBtn.addEventListener('click', () => {
            fileInput.click();
        });
        
        fileInput.addEventListener('change', handleIconUpload);
        
        if (applyBtn) {
            applyBtn.addEventListener('click', applyCustomIcon);
        }
    }
    
    function createAdminIconInterface() {
        const adminInterface = document.createElement('div');
        adminInterface.innerHTML = `
            <div id="admin-icon-panel" class="admin-icon-panel">
                <h4>Custom Property Detail Icons</h4>
                <div class="admin-icon-controls">
                    <select id="icon-type-select" class="admin-select">
                        <option value="">Select icon type...</option>
                        <option value="bedrooms">Bedrooms Icon</option>
                        <option value="beds">Beds Icon</option>
                        <option value="bathrooms">Bathrooms Icon</option>
                        <option value="guests">Guests Icon</option>
                    </select>
                    <button id="admin-icon-upload" class="admin-btn">Upload Custom Icon</button>
                    <input type="file" id="admin-icon-file-input" accept="image/*" style="display: none;">
                </div>
                <div id="admin-icon-preview" class="admin-icon-preview"></div>
                <button id="admin-apply-icon" class="admin-btn admin-btn-primary" style="display: none;">Apply to Property Detail Card</button>
                <button id="admin-reset-icons" class="admin-btn admin-btn-secondary">Reset to Default Icons</button>
            </div>
        `;
        
        // Insert before the property details grid
        const propertyDetails = document.querySelector('.property-details-grid');
        if (propertyDetails) {
            propertyDetails.parentNode.insertBefore(adminInterface, propertyDetails);
        } else {
            document.body.appendChild(adminInterface);
        }
    }
    
    function handleIconUpload(event) {
        const file = event.target.files[0];
        if (!file) return;
        
        // Validate file type and size
        if (!file.type.startsWith('image/')) {
            showToastMessage('Please upload a valid image file.', 'error');
            return;
        }
        
        if (file.size > 1024 * 1024) { // 1MB limit
            showToastMessage('Image size must be less than 1MB.', 'error');
            return;
        }
        
        const reader = new FileReader();
        reader.onload = (e) => {
            const imageData = e.target.result;
            displayIconPreview(imageData);
            
            // Store the image data for later application
            window.customIconData = imageData;
            
            const applyBtn = document.getElementById('admin-apply-icon');
            if (applyBtn) {
                applyBtn.style.display = 'block';
            }
        };
        
        reader.readAsDataURL(file);
    }
    
    function displayIconPreview(imageData) {
        const previewContainer = document.getElementById('admin-icon-preview');
        if (!previewContainer) return;
        
        previewContainer.innerHTML = `
            <div class="icon-preview-item">
                <img src="${imageData}" alt="Custom Icon Preview" class="preview-icon">
                <p>Preview: Custom Location Icon</p>
            </div>
        `;
    }
    
    function applyCustomIcon() {
        const iconTypeSelect = document.getElementById('icon-type-select');
        const selectedType = iconTypeSelect ? iconTypeSelect.value : '';
        
        if (!window.customIconData) {
            showToastMessage('No icon selected. Please upload an icon first.', 'error');
            return;
        }
        
        if (!selectedType) {
            showToastMessage('Please select an icon type first.', 'error');
            return;
        }
        
        // Save custom icon to local storage with type
        localStorage.setItem(`customDetailIcon_${selectedType}`, window.customIconData);
        localStorage.setItem(`customDetailIconTimestamp_${selectedType}`, Date.now().toString());
        
        // Apply to the specific property detail card
        updatePropertyDetailIcon(selectedType, window.customIconData);
        
        showToastMessage(`Custom ${selectedType} icon applied successfully!`, 'success');
        
        // Clear the selection
        iconTypeSelect.value = '';
        window.customIconData = null;
        
        const applyBtn = document.getElementById('admin-apply-icon');
        if (applyBtn) {
            applyBtn.style.display = 'none';
        }
        
        const previewContainer = document.getElementById('admin-icon-preview');
        if (previewContainer) {
            previewContainer.innerHTML = '';
        }
    }
    
    function updateAllMapsWithCustomIcon(iconData) {
        const mapContainers = document.querySelectorAll('.map-interactive');
        
        mapContainers.forEach((container) => {
            // Update Leaflet maps
            if (container._leaflet_id) {
                const map = container._leaflet;
                if (map) {
                    // Remove existing markers and add new one with custom icon
                    map.eachLayer(layer => {
                        if (layer instanceof L.Marker) {
                            const pos = layer.getLatLng();
                            const title = layer.options.title || 'Location';
                            
                            // Create custom icon
                            const customIcon = L.divIcon({
                                html: `<img src="${iconData}" style="width: 32px; height: 32px; object-fit: cover; border-radius: 4px;">`,
                                iconSize: [32, 32],
                                className: 'custom-location-icon'
                            });
                            
                            // Remove old marker and add new one
                            map.removeLayer(layer);
                            L.marker(pos, { icon: customIcon })
                                .addTo(map)
                                .bindPopup(title);
                        }
                    });
                }
            }
            // Update Google Maps
            else if (container.gmap && container.marker) {
                container.marker.setIcon({
                    url: iconData,
                    scaledSize: new google.maps.Size(32, 32),
                    size: new google.maps.Size(32, 32),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(16, 32)
                });
            }
        });
    }
    
    // Add event listener for reset button
    const resetBtn = document.getElementById('admin-reset-icons');
    if (resetBtn) {
        resetBtn.addEventListener('click', resetAllCustomIcons);
    }
    
    // Load existing custom icons on page load
    loadExistingCustomIcons();
}

function updatePropertyDetailIcon(iconType, iconData) {
    const detailCard = document.querySelector(`[data-detail-type="${iconType}"]`);
    if (!detailCard) return;
    
    const iconContainer = detailCard.querySelector('.detail-icon');
    if (!iconContainer) return;
    
    // Replace the existing icon with the custom one
    iconContainer.innerHTML = `
        <img src="${iconData}" width="24" height="24" alt="${iconType} icon" class="custom-detail-icon">
    `;
    
    console.log(`Updated ${iconType} icon with custom image`);
}

function resetAllCustomIcons() {
    const iconTypes = ['bedrooms', 'beds', 'bathrooms', 'guests'];
    
    iconTypes.forEach(type => {
        // Remove from localStorage
        localStorage.removeItem(`customDetailIcon_${type}`);
        localStorage.removeItem(`customDetailIconTimestamp_${type}`);
        
        // Reset to default icon
        const detailCard = document.querySelector(`[data-detail-type="${type}"]`);
        if (detailCard) {
            const iconContainer = detailCard.querySelector('.detail-icon');
            if (iconContainer) {
                const defaultIcon = iconContainer.querySelector('.default-detail-icon');
                if (defaultIcon) {
                    // Show default icon, hide custom
                    const customIcon = iconContainer.querySelector('.custom-detail-icon');
                    if (customIcon) {
                        customIcon.style.display = 'none';
                    }
                    defaultIcon.style.display = 'block';
                }
            }
        }
    });
    
    showToastMessage('All custom icons reset to defaults!', 'success');
}

function loadExistingCustomIcons() {
    const iconTypes = ['bedrooms', 'beds', 'bathrooms', 'guests'];
    
    iconTypes.forEach(type => {
        const savedIcon = localStorage.getItem(`customDetailIcon_${type}`);
        if (savedIcon) {
            updatePropertyDetailIcon(type, savedIcon);
            console.log(`Loaded saved custom ${type} icon`);
        }
    });
}

/**
 * Interactive Map Functionality
 */
function initializeInteractiveMap() {
    console.log('Initializing interactive map');
    
    // Find all interactive map containers
    const mapContainers = document.querySelectorAll('.map-interactive');
    
    if (mapContainers.length === 0) {
        console.log('No interactive maps found on page');
        return;
    }
    
    // Listen for messages from parent or iframe
    window.addEventListener('message', function(event) {
        // Verify message is a map update
        if (event.data && event.data.type === 'mapUpdate') {
            console.log('Received map update message:', event.data);
            
            // Update all maps with the new coordinates
            updateAllMapsFromMessage(event.data);
        }
    });
    
    // Check URL parameters for real-time location updates
    const urlParams = new URLSearchParams(window.location.search);
    const urlLat = urlParams.get('lat');
    const urlLng = urlParams.get('lng');
    const urlZoom = urlParams.get('zoom');
    
    // Check if we're in an iframe and need to send initial coordinates to parent
    if (window !== window.parent) {
        console.log('Map is in an iframe, checking for coordinates to send to parent');
        
        // Only send message if we have valid coordinates from URL or will get them from mapContainers
        // We'll send the message after we've processed the mapContainers
    }
    
    mapContainers.forEach((container, index) => {
        // Get map data from data attributes
        let lat = parseFloat(container.dataset.lat);
        let lng = parseFloat(container.dataset.lng);
        let zoom = parseInt(container.dataset.zoom || '15');
        const markerTitle = container.dataset.markerTitle || 'Location';
        
        // Override with URL parameters if available
        if (urlLat && !isNaN(parseFloat(urlLat))) {
            lat = parseFloat(urlLat);
            console.log('Using URL parameter for latitude:', lat);
        }
        
        if (urlLng && !isNaN(parseFloat(urlLng))) {
            lng = parseFloat(urlLng);
            console.log('Using URL parameter for longitude:', lng);
        }
        
        if (urlZoom && !isNaN(parseInt(urlZoom))) {
            zoom = parseInt(urlZoom);
            console.log('Using URL parameter for zoom:', zoom);
        }
        
        // If we're in an iframe, send the coordinates to the parent after processing
        if (window !== window.parent && index === 0) {
            console.log('Sending initial coordinates to parent from map container');
            window.parent.postMessage({
                type: 'mapUpdate',
                lat: lat,
                lng: lng,
                zoom: zoom
            }, '*');
        }
        
        // Validate coordinates
        if (isNaN(lat) || isNaN(lng)) {
            console.error('Invalid map coordinates:', container.dataset);
            return;
        }
        
        console.log(`Initializing map ${index + 1} at coordinates: ${lat}, ${lng}`);
        
        // Check if Leaflet is available
        if (typeof L !== 'undefined') {
            // Initialize Leaflet map
            const map = L.map(container).setView([lat, lng], zoom);
            
            // Add OpenStreetMap tile layer
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);
            
            // Add marker
            const marker = L.marker([lat, lng])
                .addTo(map)
                .bindPopup(markerTitle)
                .openPopup();
            
            // Update URL parameters when map is moved or zoomed
            map.on('moveend', function() {
                const center = map.getCenter();
                updateMapUrlParameters(center.lat, center.lng, map.getZoom());
            });
            
            console.log('Leaflet map initialized');
        }
        // Check if Google Maps is available
        else if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
            // Initialize Google Maps
            const map = new google.maps.Map(container, {
                center: { lat, lng },
                zoom: zoom
            });
            
            // Add marker
            const marker = new google.maps.Marker({
                position: { lat, lng },
                map,
                title: markerTitle
            });
            
            // Update URL parameters when map is moved
            map.addListener('idle', function() {
                const center = map.getCenter();
                updateMapUrlParameters(center.lat(), center.lng(), map.getZoom());
            });
            
            console.log('Google Maps initialized');
        }
        else {
            console.error('No map library (Leaflet or Google Maps) available');
            container.innerHTML = `
                <div class="map-fallback">
                    <p>Map library not loaded. <a href="https://maps.google.com/?q=${lat},${lng}" target="_blank" rel="noopener">View on Google Maps</a></p>
                </div>
            `;
        }
    });
}

/**
 * Mobile-specific functionality
 */
function initializeMobileFeatures() {
    console.log('Mobile features: Simple gallery swipe enabled');
    // Only basic inline gallery swipe is active
    // Modal functionality is disabled
    // No fancy effects - just simple left/right navigation
}

/**
 * Initialize mobile swipe functionality for gallery modal (simplified)
 */
function initializeMobileGallerySwipe() {
    console.log('Modal gallery swipe disabled - using simple inline gallery only');
    // Modal functionality removed - only inline gallery swipe is active
}

// Utility function to handle errors gracefully
window.addEventListener('error', (e) => {
    console.warn('JavaScript error caught:', e.error);
});

console.log('Airbnb Listing JavaScript fully initialized');
